import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ValueItem } from '@/types/stockSummary';

export type GetStockSummaryReponse = {
  exception: null;
  state: number;
  value: ValueItem[];
  isFaulted: boolean;
  isSuccess: boolean;
};

export const getStockSummary = async (
  armador: string
): Promise<ValueItem[]> => {
  try {
    const res = await apiClient.post<GetStockSummaryReponse>(
      Endpoints.StockSummary,
      { armador }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
